import { Margin } from "@mui/icons-material";

export const PendingPackagingStyle = {
  titleBar: {
    backgroundColor: "#64b5f6",
    padding: "8px",
    textAlign: "center",
    position: "sticky", // スクロール固定
    top: 0, // 画面上部固定
    zIndex: 1000,
    marginBottom: "8px",
  },
  titleText: {
    color: "white",
    fontWeight: "bold",
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "space-between",
    padding: "20px",
  },
  orangeButton: {
    backgroundColor: "#e0a56d",
    color: "white",
    fontWeight: "bold",
    boxShadow: 3,
    "&:hover": {
      backgroundColor: "#d79652",
    },
  },
  floatingRegisterButton: {
    position: "fixed",
    bottom: 24, // 画面下からの距離
    right: 24, // 画面右からの距離
    width: 90,
    height: 90,
    borderRadius: "50%",
    backgroundColor: "#e0a56d",
    color: "white",
    fontWeight: "bold",
    boxShadow: 6,
    zIndex: 2000,
    "&:hover": {
      backgroundColor: "#d79652",
    },
  },
  numberField: {
    width: "100px",
    "& input[type='number']": {
      MozAppearance: "textfield", // Firefox
    },
    "& input[type='number']::-webkit-inner-spin-button": {
      WebkitAppearance: "none", // Chrome, Safari
      margin: 0,
    },
    "& input[type='number']::-webkit-outer-spin-button": {
      WebkitAppearance: "none", // Chrome, Safari
      margin: 0,
    },
  },
};
